const attributes = {
	id: {
		type: 'string',
	},
	uniqueID: {
		type: 'string',
		default: '',
	},
	blockStyle: {
		type: 'object',
	},
	gapDBetweenBlocks: {
		type: 'number',
		default: 0,
	},
	gapTBetweenBlocks: {
		type: 'number',
		default: 0,
	},
	gapMBetweenBlocks: {
		type: 'number',
		default: 0,
	},
	blockBorderRadius: {
		type: 'number',
		default: 0,
	},
	contentBoxHeight: {
		type: 'number',
		default: 250,
	},
	deskCols: {
		type: 'number',
		default: 3,
	},
	tabCols: {
		type: 'number',
		default: 2,
	},
	mobCols: {
		type: 'number',
		default: 1,
	},
	sloganTextAlignment: {
		type: 'string',
		enum: [ 'left', 'center', 'right' ],
		default: 'center',
	},
	titleTag: {
		type: 'string',
		default: 'h3',
	},
	descriptionTag: {
		type: 'string',
		default: 'p',
	},
	titleColor: {
		type: 'string',
	},
	descriptionColor: {
		type: 'string',
	},
	contentBoxPadding: {
		type: 'number',
		default: 10,
	},
	imageObjectFit: {
		type: 'string',
		default: 'cover',
	},
	imageAspectRatio: {
		type: 'string',
		default: '1/1',
	},
};

export default attributes;
